export const faAlphabet = "ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی";
export const faNumber = "۰۱۲۳۴۵۶۷۸۹";
export const faShortVowels = "َُِ";
export const faOthers = "‌آاً";
export const faMixedWithArabic = "ًٌٍَُِّْٰٔءك‌ةۀأإيـئؤ،";
export const faText = faAlphabet + faNumber + faShortVowels + faOthers;
export const faComplexText = faText + faMixedWithArabic;
